<template>
  <header class="header">
    <router-link to="/" class="header_logo">
      <picture>
        <source
          media="(max-width: 899px)"
          srcset="@/assets/images/common/logo-header.svg"
        />
        <img
          src="@/assets/images/common/logo-header-outline-s.png"
          alt="未来のドクターへ、期待以上の出会いを。マイナビ RESIDENT"
        />
      </picture>
    </router-link>
  </header>
</template>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';

.header {
  display: flex;
  align-items: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  justify-content: center;
  height: 68px;
  flex-shrink: 0;

  @include mixins.media() {
    height: 56px;
  }
}

.header_logo {
  width: 176px;

  @include mixins.media() {
    width: 180px;
  }
}
</style>

<script>
export default {
  name: 'HeaderRegist'
}
</script>
